// extracted by mini-css-extract-plugin
module.exports = {"button":"_2Y99o","formButton":"_1TaVZ","form":"N9Gyk","responses":"lntzx","response":"LK2N9","error":"_13ljK","summaryBlock":"_2PdOw","fullButton":"_1UUTA","title":"_3WB1Q"};